import script from "./IdentitySection.vue?vue&type=script&setup=true&lang=js"
export * from "./IdentitySection.vue?vue&type=script&setup=true&lang=js"

import "./IdentitySection.vue?vue&type=style&index=0&id=b4e8bff0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4e8bff0"]])

export default __exports__